const BASE_URL = "https://buyhome-backend.testyoursite.xyz";

export default BASE_URL

